import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useAppUser } from '../hook/useAppUser';
import UserAppClientCreateEditForm from '../components/userAppClient/createEditForm/UserAppClientCreateEditForm';
import useCompanies from '../services/companyQueries';
import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import { Loading } from 'shared/components';
import {
  BackEndDomicilio,
  PayLoadEditParticularUser,
  PayLoadEditUser,
  transformUserToFormValues,
  UserFormValues
} from '../models/appUserModel';
import PageHeader from 'layout/components/PageHeader';
import PageContainer from 'layout/components/PageContainer';
import { Button } from '@vadiun/react-components';
import { Role } from '../models/appUsersModels';
import { domicilioBuilder } from 'app/domicilio/models/DomicilioModel';

const AppUsersEdit = () => {
  const history = useHistory();
  const {
    appUser,
    loadingAppUser,
    errorAppUser,
    editAppUserCorporate,
    editAppUserParticular
  } = useAppUser();
  const [appUserFormValues, setAppUserFormValues] = useState<UserFormValues>(
    {} as UserFormValues
  );
  const CompaniesService = useCompanies();

  const { data: companies } = useSuperQuery(CompaniesService.getCompanies, {
    showSpinner: true
  });

  const handleCancel = () => {
    history.push('/main/inventories/appUsers');
  };

  const edit = async (appUserFormValues: UserFormValues) => {
    if (appUserFormValues.role === Role.CORPORATE) {
      const userApp: PayLoadEditUser = {
        id: appUser!._id,
        fullname: appUserFormValues.fullname!!,
        email: appUserFormValues.email,
        phone: appUserFormValues.phone || '',
        company_id: appUserFormValues.company!.company_id
      };
      await editAppUserCorporate(userApp);
    } else {
      const userApp: PayLoadEditParticularUser = {
        id: appUser!._id,
        first_name: appUserFormValues.first_name!!,
        last_name: appUserFormValues.last_name!!,
        email: appUserFormValues.email,
        phone_number_one: appUserFormValues.phone || '',
        alias: appUserFormValues.alias || '',
        address: appUserFormValues.address?.latitud && appUserFormValues.address.latitud !== 0 ? domicilioBuilder.toBackEnd(
          appUserFormValues.address
        ) as BackEndDomicilio : undefined
      };
      await editAppUserParticular(userApp);
    }

    handleCancel();
  };

  useEffect(() => {
    if (appUser) {
      setAppUserFormValues(transformUserToFormValues(appUser));
    }
  }, [appUser]);

  if (
    loadingAppUser ||
    !appUserFormValues.role ||
    !(companies && companies.length > 0)
  ) {
    return <Loading />;
  }
  if (errorAppUser) {
    handleCancel();
  }

  return (
    <>
      <PageHeader
        area="Comercial - Gestión de Clientes"
        title="Empresa"
        subArea={'Editar usuario de app'}
        toolbar={
          <Link to={'/main/inventories/appUsers'} className="inline-flex items-center">
            <Button variant="light">Volver</Button>
          </Link>
        }
      />
      <PageContainer>
        <div className="flex w-full justify-center">
          <UserAppClientCreateEditForm
            onSubmit={edit}
            onCancel={handleCancel}
            companies={companies}
            isEditing
            initialValues={appUserFormValues}
          />
        </div>
      </PageContainer>
    </>
  );
};

export default AppUsersEdit;
